// extracted by mini-css-extract-plugin
export var dataCell = "_p1-2";
export var dataRow = "_p1-0";
export var headerRow = "_p1-1";